<template>
  <div
class="rounded-full px-3 py-1 text-xs text-pretty text-center flex items-center"
    :class="[statusColor, statusTextColor]"
  >
  <Loader class="w-3.5 h-3.5 mr-1" />
  <span class="capitalize font-medium mr-1">
    {{ props.statusType === 'referralStatus' ? 'Referral' : props.statusType }}:
  </span>
    {{ statusLabel }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  applicationStatusOptions,
  interviewStatusOptions,
  referralTypeOptions,
  referralStatusOptions
} from '@/const/applicationStatuses'
import { Loader } from 'lucide-vue-next'

type StatusType = 'application' | 'interview' | 'referralType' | 'referralStatus'

const props = defineProps<{
  status: string,
  statusType: StatusType
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()

const statusOptionsMap = {
  application: applicationStatusOptions,
  interview: interviewStatusOptions,
  referralType: referralTypeOptions,
  referralStatus: referralStatusOptions
}



const statusLabel = computed(() => 
  statusOptionsMap[props.statusType].find(option => option.value === props.status)?.label || props.status
)

const statusColor = computed(() => 
  statusOptionsMap[props.statusType].find(option => option.value === props.status)?.bgColor || 'bg-gray-100'
)

const statusTextColor = computed(() => 
  statusOptionsMap[props.statusType].find(option => option.value === props.status)?.textColor || 'text-gray-700'
)


</script>